import { getHeaders, host } from '.';

const parseResponse = (res) => {
  if (!res.ok) throw new Error(res.statusText);
  return res.json();
};

export const fetchAccounts = async () => {
  const headers = await getHeaders();

  return fetch(host + `/accounts`, { headers, method: 'GET' })
    .then(parseResponse)
    .then((data) => {
      if (data.error) return [];
      return data;
    })
    .catch(() => {});
};

export const createAccount = async ({ name, code, owner, secondaryOwner, organization }) => {
  const headers = await getHeaders();

  return fetch(host + `/accounts`, {
    headers,
    method: 'POST',
    body: JSON.stringify({ name, code, owner, secondaryOwner, organization }),
  })
    .then(parseResponse);
};

export const updateAccount = async ({ accountId, id, name, code, owner, secondaryOwner, organization }) => {
  const headers = await getHeaders();

  return fetch(host + `/accounts/${accountId}`, {
    headers,
    method: 'PUT',
    body: JSON.stringify({
      accountId,
      id,
      name,
      code,
      owner,
      secondaryOwner: secondaryOwner.userId ? { userId: secondaryOwner.userId } : null,
      organization,
    }),
  })
    .then(parseResponse)
    .catch(() => {});
};
